const servicesDetailsTableStyle = () => ({
	expander: {
		'& .expandWrapper': {
			textTransform: 'capitalize',
		},
		'& > div > div > div > div': {
			justifyContent: 'space-between',
			padding: '0 15px',
		},
	},
});

export default servicesDetailsTableStyle;
